var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.InputRadioTile,_vm._g(_vm._b({attrs:{"value":_vm.value,"text":_vm.text,"id":_vm.keyName + _vm.value,"model-value":_vm.modelValue}},'InputRadioTile',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }